export default "__VITE_ASSET__Cuyp9lNj__"